import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuService } from './menu.service';
import { CompanySwitcherService } from '@mitel/cloudlink-console-components';
import { AccountsService } from './accounts.service';

export class ShortNavItem { 
	keyword: string;
	fullMatch: boolean;
	navUrl: string[];
	matchTo?: string;
	setCurrentAccount?: boolean;
	useCurrentAccount?: boolean;
	params?: {}
}

// :id will always mean the account id
// for the rest tpf the urls with an id, use the type in the keyword, i.e 'userid'
export const ShortNavUrls = [
	{
		keyword: '/managed-accounts',
		fullMatch: true,
		navUrl: '/managed-accounts'
	},
	{
		keyword: '/gateway',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/gateway'
	},
	{
		keyword: '/orders',
		fullMatch: true,
		navUrl: '/orders'
	},
	{
		keyword: '/orders/id',
		matchTo: '/orders/',
		fullMatch: false,
		setCurrentAccount: true,
		navUrl: '/orders/:id'
	},
	{
		keyword: '/dashboard',
		fullMatch: true,
		navUrl: '/'
	},
	{
		keyword: '/accounts',
		fullMatch: true,
		navUrl: '/accounts'
	},
	{
		keyword: '/accounts/id',
		matchTo: '/accounts/',
		fullMatch: false,
		setCurrentAccount: true,
		navUrl: '/accounts/:id'
	},
	{
		keyword: '/newaccount',
		fullMatch: true,
		params: {new: true},
		navUrl: '/accounts'
	},
	{
		keyword: '/users',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/users'
	},
	{
		keyword: '/users/userid',
		matchTo: '/users/',
		fullMatch: false,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/users/:userid'
	},
	{
		keyword: '/newUser',
		fullMatch: true,
		params: {new: true},
		useCurrentAccount: true,
		navUrl: '/accounts/:id/users'
	},
	{
		keyword: '/accountSubscriptions/id',
		matchTo: '/accountSubscriptions/',
		fullMatch: false,
		setCurrentAccount: true,
		navUrl: '/accounts/:id/subscriptions'
	},
	{
		keyword: '/ccabout',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/ccdashboard'
	},
	{
		keyword: '/ccskills',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/ccskills'
	},
	{
		keyword: '/ccrouting',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/ccrouting'
	},
	{
		keyword: '/ccembeddedchats',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/ccembeddedchats'
	},
	{
		keyword: '/ccreports',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/ccreports'
	},
	{
		keyword: '/cccodes',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/cccodes'
	},
	{
		keyword: '/cctemplates',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/cctemplates'
	},
	{
		keyword: '/ccsettings',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/ccsettings'
	},
	{
		keyword: '/ccintegrations',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/ccintegrations'
	},
	{
		keyword: '/ccnumbers',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/ccnumbers'
	},
	{
		keyword: '/varouting',
		fullMatch: true,
		useCurrentAccount: true,
		navUrl: '/accounts/:id/varouting'
  }
];

@Injectable({
	providedIn: 'root'
})

export class ChildCommsService {

	constructor( private menuService: MenuService,
				private companySwitcherService: CompanySwitcherService,
				private accountsService: AccountsService,
				private translateService: TranslateService,
				private router: Router ) 
	{ }

	sendChildIframeMessage( message:any )
	{
		var iframeSpa= (<HTMLIFrameElement>document.getElementById("iframeSpa"));

		if ( iframeSpa && iframeSpa.contentWindow )
			iframeSpa.contentWindow.postMessage(message, '*');
	}
	
	notifyChildrenOfLanguageChange( langCode: string )
	{
		let data = {
			type: "CL_LANGCHANGE",
			data: langCode
		}
		this.sendChildIframeMessage(data);
		
		const event = new CustomEvent('setLanguage', { detail: langCode });
		window.dispatchEvent(event);
	}

	sentChildrenCurrentLanguage(  ) {
		let langCode = this.translateService.currentLang;
		
		const event = new CustomEvent('setLanguage', { detail: langCode });
		window.dispatchEvent(event);
	}

	sendChildFeatureFlags(featureFlags: any[]) {
		const event = new CustomEvent('setFeatureFlags', { detail: featureFlags });
		window.dispatchEvent(event);

    //iframe
    let data = {
      type: "CL_FEATURE_FLAGS",
      flags: featureFlags
    };
    this.sendChildIframeMessage(data);
  }

	notifyChildToExit()
	{
		this.sendChildIframeMessage("CL_NOTIFYANDEXIT");
	}

	sendChildSwitchedAccountMessage(account) {
		const event = new CustomEvent('switchedAccount', { detail: account });
		window.dispatchEvent(event);
	}	
	
	handleChildRequestToNavigate( message: any )
	{
		if ( message && message.data && message.data.type == "CL_NAVIGATION" )
		{
			// match the passed in keywords to determine what url to use
			if ( message.data.url )
			{
				// we need to make a match of the keywards
				for ( var i = 0; i < ShortNavUrls.length; i++ )
				{
					if ( ShortNavUrls[i].fullMatch === true )
					{
						if ( ShortNavUrls[i].keyword === message.data.url )
						{
							let navUrl = ShortNavUrls[i].navUrl;
							let parts = navUrl.substr(1).split('/');
							if ( ShortNavUrls[i].useCurrentAccount === true )
							{
								// this means there is an 'id' in the url that must be replaced 
								// by the current account id
								let accountId = this.accountsService.getCurrentAccount().accountId;

								let ndx = parts.indexOf(':id');
								if ( ndx != -1 )
									parts[ndx] = accountId;
							}
							if ( message.data.params as any )
								parts.push( message.data.params );

							if ( ShortNavUrls[i].params )
								parts.push( ShortNavUrls[i].params as any );
							console.log("Child asked to navigate", message.data, parts);
							this.router.navigate( parts );
							
						}
					}
					else // in this case there is a part match because there is an id to use
					{
						if ( message.data.url.indexOf(ShortNavUrls[i].matchTo) == 0 )
						{
							let navUrl = ShortNavUrls[i].navUrl;
							let accountId = undefined;

							let parts = navUrl.substr(1).split('/');

							if ( ShortNavUrls[i].useCurrentAccount === true )
							{
								// this means there is an 'id' in the url that must be replaced 
								// by the current account id
								accountId = this.accountsService.getCurrentAccount().accountId;
								let ndx = parts.indexOf(':id');
								if ( ndx != -1 )
									parts[ndx] = accountId;
							}

							// because it was a partial match for the url, this means there is another id type
							// we need to use and replace in the url
							let idndx =  message.data.url.lastIndexOf('/');
							let contextId = message.data.url.substr( idndx +1 );
							if ( accountId == undefined )
								accountId = contextId;
		
							let idType = ShortNavUrls[i].keyword.substr(ShortNavUrls[i].keyword.lastIndexOf('/')+1);

							let ndx = parts.indexOf( ':' + idType );
							if ( ndx != -1 )
								parts[ndx] = contextId;

							if ( message.data.params as any )
								parts.push( message.data.params );

							// currently there is no example of this
							// saving it for future
							//if ( ShortNavUrls[i].params )
							//	parts.push( ShortNavUrls[i].params as any );
								
							console.log("Child asked to navigate", message.data, parts);
							
							if ( ShortNavUrls[i].setCurrentAccount === true )
							{
								this.menuService.initialRoute = parts;
								this.menuService.isSwitcherProcessingRequired = true;
								this.companySwitcherService.setCurrentAccountById(accountId);
							}
							else
							{
								this.router.navigate( parts, message.data.queryParams ?? {} );
							}
						}
					}
				}
			}
		}

	}
	
}
